// REDISENO-SMARTMEDIC FASE 2 (TopBar) -- título de la pantalla actual.
//
// Hoy la barra superior tiene una hamburguesa, un vacío enorme y el avatar:
// nada dice dónde estás. El título sale de la RUTA (no de cada pantalla) para
// que ninguna se quede sin él y para no tener que tocar 40 archivos.
//
// La coincidencia es por prefijo más largo, igual que el ítem activo del menú:
// `/auditoria-clinica/3109` hereda el título del módulo si no tiene uno propio.

export const TITULOS = {
    "/gestion_citas": "Citas",
    "/agenda": "Mi agenda",
    "/pacientes": "Pacientes",
    "/paciente_historial": "Historial clínico",
    "/sigvital": "Signos vitales",
    "/resultados": "Resultados",
    "/factura-listar": "Facturas",
    "/factura-listar-por-cobrar": "Matriz de seguros",
    "/factura-crear": "Crear factura",
    "/clientes": "Clientes",
    "/matrizatenciones": "Matriz de atenciones",
    "/reportes/coberturas": "Reporte general de atenciones",
    "/reportes/produccion-facturacion": "Producción / Facturación",
    "/reportes/cartera-aseguradoras": "Cartera por aseguradora",
    "/reportes/documentos-anulados": "Documentos anulados",
    "/caja-general": "Caja general",
    "/auditoria-clinica": "Auditoría clínica",
    "/auditoria-clinica/clasico": "Auditoría clínica (listado clásico)",
    "/configuracion": "Configuración",
    // SEGUROS-PLANES: por prefijo más largo, la ficha y sus pestañas
    // (`/configuracion/seguros/17/planes`) heredan este título. El nombre de la
    // aseguradora va en el subtítulo, que sí lo pone cada pantalla.
    "/configuracion/seguros": "Aseguradoras",
    "/soporte": "Soporte",
    "/admin/api-docs": "Documentación de la API",
};

export function tituloDeRuta(pathname, titulos = TITULOS) {
    let mejor = null;
    for (const ruta of Object.keys(titulos)) {
        if (pathname === ruta || pathname.startsWith(ruta + "/")) {
            if (!mejor || ruta.length > mejor.length) mejor = ruta;
        }
    }
    return mejor ? titulos[mejor] : "";
}
